export default "__VITE_ASSET__D_1BfW_f__"